import { axiosApiInstance } from "@/lib/axios";
import { API_PORTAL_URL } from "@/lib/config";
import { createAsyncThunk } from "@reduxjs/toolkit";

export const insertJobApplication = createAsyncThunk(
  "JobApplication/InsertJobApplication",
  async (formdata: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_PORTAL_URL}/JobApplication/InsertJobApplication`,
        formdata,
      );
      // SuccessToast(response.data?.Data?.Details || "Success");
      return response.data?.Data;
    } catch (error: any) {
      console.error("Error inserting job application:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const getAllActivePosition = createAsyncThunk(
  "Position/FindAllActivePosition",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_PORTAL_URL}/Position/FindAllActivePosition`,
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Positions:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);
